/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ListingSimulationParams_jsonld = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    listingId?: string;
    listingType?: ListingSimulationParams_jsonld.listingType;
    adjustedAmortisationAbo?: number | null;
    pricePoint?: number | null;
    session?: number | null;
    ctr?: number | null;
    constOtaMultiplier?: number | null;
    averageBasket?: number | null;
    aboMultiplier?: number;
    otaMultiplier?: number;
    readonly emptyValues?: boolean;
};
export namespace ListingSimulationParams_jsonld {
    export enum listingType {
        COUNTRY = 'country',
        CITY = 'city',
        REGION = 'region',
        LEGACY_COUNTRY = 'legacy_country',
        LEGACY_VOIDESHIP = 'legacy_voideship',
        LEGACY_CITY = 'legacy_city',
        LEGACY_REGION = 'legacy_region',
    }
}
